export const queryKeys = {
  assetRules: (assetId: number) => ['ASSET_RULES', assetId],
  channelAssets: ['CHANNEL_ASSETS'],
  categoryTree: ['CATEGORY_TREE'],
  categoryTreeUidas: (assetIds: number[]) => ['CATEGORY_TREE_UIDA', assetIds],
  channelCollection: (collectionId: number, includeAdult: boolean, kSql: string | undefined) => [
    'CHANNEL_COLLECTION',
    collectionId,
    includeAdult,
    kSql,
  ],
  channelPrograms: (channelId: number, dayISO: string) => ['CHANNEL_PROGRAMS', channelId, dayISO] as const,
  channelProgramsAllDays: (channelId: number) => ['CHANNEL_PROGRAMS', channelId] as const,
  collectionMeta: (id: number) => ['COLLECTION_META', id],
  collection: (id: string, pageSize: number) => ['COLLECTION', id, pageSize],
  configuration: ['CONFIGURATION'],
  continueWatching: (id: string, pageSize: number) => ['CONTINUE_WATCHING', id, pageSize],
  disabled: ['DISABLED'],
  entitledChannels: ['ENTITLED_CHANNELS'],
  favoriteChannels: ['FAVORITE_CHANNELS'],
  lastWatched: ['LAST_WATCHED'],
  mostWatched: ['MOST_WATCHED'],
  personalLineup: ['PERSONAL_LINEUP'],
  recommendations: (id: string, pageSize: number) => ['RECOMMENDATIONS', id, pageSize],
  rentals: (id: string, pageSize: number) => ['RENTALS', id, pageSize],
  search: (id: string) => ['SEARCH', id],
  topShelf: (id: string) => ['TOP_SHELF', id],
  logo: (collectionId: number) => ['LOGO', collectionId],
  playbackContext: (
    adapterCodec: string,
    adapterDrm: string,
    adapterQuality: string,
    assetId: string,
    streamerType: string,
  ) => ['PLAYBACK_CONTEXT', adapterCodec, adapterDrm, adapterQuality, assetId, streamerType],
};

export type ChannelProgramsQueryKey = ReturnType<typeof queryKeys.channelPrograms>;

export type QueryKey = keyof typeof queryKeys;

// TODO This is not used currently. Fill in or delete after enabling the persistent cache.
export const queryPersistCachingMap: Record<string, () => boolean> = {};
